import { createContext, useContext } from "react";

const AppBarActionsContext = createContext(null);

export const useAppBarActionsTarget = () => useContext(AppBarActionsContext);

export default AppBarActionsContext;
